import { useMemo, useState } from "react";
import matchesShowIf from "./showIf";
import { shuffleArray } from "../../helpers";

export const emptyResponse = { answers: [], otherChecked: false, otherText: "", score: null, text: "" };

const responseFromPrefill = (question, value) => {
  if(question.type === "nps") {
    return { ...emptyResponse, score: value };
  }
  if(question.type === "open") {
    return { ...emptyResponse, text: String(value) };
  }
  return { ...emptyResponse, answers: [].concat(value) };
};

export default function useSurveyFlow({ intro, prefill, questions }) {
  const prefilled = useMemo(() => (
    questions.filter((question) => prefill && prefill[question.identifier] !== undefined && prefill[question.identifier] !== null)
  ), [questions, prefill]);

  const [responses, setResponses] = useState(() => (
    prefilled.reduce((acc, question) => {
      acc[question.identifier] = responseFromPrefill(question, prefill[question.identifier]);
      return acc;
    }, {})
  ));
  const [stepIndex, setStepIndex] = useState(0);
  const orderedOptions = useMemo(() => (
    questions.reduce((acc, question) => {
      if(question.type === "choice") {
        acc[question.identifier] = question.randomize ? shuffleArray(question.options.slice()) : question.options;
      }
      return acc;
    }, {})
  ), [questions]);

  const visibleQuestions = questions.filter((question) => (
    !prefilled.includes(question) && matchesShowIf(question.showIf, responses)
  ));
  const steps = (intro ? [{ type: "intro" }] : []).concat(visibleQuestions, [{ type: "thanks" }]);
  const thanksIndex = steps.length - 1;
  const step = steps[Math.min(stepIndex, thanksIndex)];
  const question = step.type === "intro" || step.type === "thanks" ? null : step;
  const response = question ? (responses[question.identifier] || emptyResponse) : emptyResponse;

  const updateResponse = (changes) => {
    setResponses((current) => ({
      ...current,
      [question.identifier]: { ...(current[question.identifier] || emptyResponse), ...changes }
    }));
  };

  return {
    advanceFrom: (fromIndex) => setStepIndex((current) => (current === fromIndex ? current + 1 : current)),
    back: () => setStepIndex((current) => current - 1),
    next: () => setStepIndex((current) => current + 1),
    orderedOptions,
    prefilled,
    question,
    response,
    responses,
    step,
    stepIndex,
    thanksIndex,
    updateResponse
  };
}
